import React from 'react'
import '../../App.css';
import ContactHero from '../ContactHero';
import ContactDetails from '../ContactDetails';

const Contact = () => {
  return (
    <>
    <ContactHero/>
    <ContactDetails/>
      
    </>
  )
}

export default Contact
